<template>
  <div>
    <base-card>
      <div class="warning-container d-flex align-center">
        <div class="col-xs-8 pt_25 mt_30 mb_25 warning-icon-container">
          <i class="warning-icon far fa-exclamation-circle" />
          <p class="warning-title text-center mt_35">ATENÇÃO!</p>
          <p class="warning-subtitle text-center mt_15">Remover esse módulo significa:</p>
        </div>
        <div class="hair-line col-xs-12"></div>
        <div class="warning-text mt_25 mb_10 col-xs-12">
          <p class="mb_15">- Acontece tal coisa com tal coisa.</p>
          <p class="mb_15">- Tal tela irá fazer isso</p>
          <p class="mb_15">- A função A não irá mais funcionar</p>
          <p class="mb_15">- Você perderá tais informações</p>
          <p class="mb_15">- Entre outras perdas</p>
        </div>
        <div class="hair-line col-xs-12"></div>
        <div class="warning-until col-xs-8 my_20">
          <p class="text-center">
            Você poderá usar este módulo até 27/01/2021, depois disso ele ficará indisponível
          </p>
        </div>
      </div>
      <div class="d-flex justify-center flex-column align-center">
        <div class="hair-line col-xs-12"></div>
        <div class="pt_30 col-xs-10 d-flex align-stretch warning-link-container">
          <base-button design="one" text="VOLTAR PARA A SEGURANÇA" @click="$emit('closeDrawer')" />
        </div>
        <div class="col-xs-10 mt_30 d-flex align-stretch warning-link-container">
          <base-button text="REMOVER MÓDULO" @click="$emit('confirm')" />
        </div>
      </div>
    </base-card>
  </div>
</template>
<script>
import BaseDrawer from "@/components/Drawer";
import BaseButton from "@/components/Button";
import BaseCard from "@/components/Card";

export default {
  components: { BaseButton, BaseCard }
};
</script>
<style scoped>
.warning-container {
  flex-direction: column;
}

.hair-line {
  border-bottom: 0.2px solid #99999955;
}

.warning-container .warning-icon-container {
  text-align: center;
}

.warning-container .warning-icon-container .warning-icon {
  font-size: 80px;
  color: #df465ccc;
  opacity: 1;
}

.warning-link-container .btn {
  flex: 1;
}

.warning-title {
  font: normal normal bold 16px/19px Lato;
  letter-spacing: 0px;
  color: #e56b7c;
}

.warning-text p, .warning-subtitle {
  font: normal normal 300 16px/19px Lato;
  letter-spacing: 0px;
  color: #999999;
  opacity: 1;
}

.warning-until p {
  font: normal normal bold 14px/25px Lato;
  letter-spacing: 0px;
  color: #BBBBBB;
}
</style>